module.exports = __webpack_public_path__ + "static/media/landing-bg-nodizurc.a8de03ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing-bg-nodizurc.jpg
// module id = 1526
// module chunks = 0